<div class="wrapper">
    <div class="placeholder" (click)="trigger()" *ngIf="selected.length == 0">{{placeholder}}</div>
    <div class="values" *ngIf="selected.length != 0">
        <div class="item" *ngFor="let item of selected">
            {{item[label]}}
            <svg (click)="remove(item)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
        </div>
        <div (click)="trigger()"  class="trigger"></div>
    </div>
    <svg (click)="trigger()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
         stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
    </svg>
</div>
<div class="dropdown" [ngClass]="{active:toggle}">
    <div class="search">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
        </svg>
        <input #input (keyup)="debounced_search(input.value)">
    </div>
    <ul class="values" [ngClass]="{active:toggle}">
        <li *ngFor="let value of _values" (click)="select(value)">
            {{value[label]}}
        </li>
    </ul>
</div>
